import { useQuery } from "@apollo/client";

import { getFragmentData } from "../../__generated__";
import {
  InvoiceByIdDocument,
  InvoiceDetailFieldsFragmentDoc,
  InvoiceFieldsFragmentDoc,
} from "../../__generated__/graphql";
import type { InvoiceDetailData } from "../types";

export function useInvoiceById(invoiceId: string) {
  const result = useQuery(InvoiceByIdDocument, {
    skip: !invoiceId,
    variables: { id: invoiceId },
    notifyOnNetworkStatusChange: true,
  });

  // Detail spreads the base fragment; unmask both so callers get one flat object.
  const detail = getFragmentData(InvoiceDetailFieldsFragmentDoc, result.data?.invoiceById);
  let invoice: InvoiceDetailData | null = null;
  if (detail) {
    // Drop the masking marker: once both fragments are read, the object is plain data.
    const { " $fragmentRefs": _refs, " $fragmentName": _name, ...detailFields } = detail;
    const { " $fragmentName": _baseName, ...baseFields } = getFragmentData(
      InvoiceFieldsFragmentDoc,
      detail,
    );
    invoice = { ...baseFields, ...detailFields };
  }

  return { invoice, ...result };
}
